import config from "@/config/config";
import { msalInstance } from "@/authConfig";
import { AccountInfo } from "@azure/msal-browser";
import { ref } from "@vue/composition-api";

const _token = ref("");
const _adGroups = ref<Array<string>>([]);
const msGraphScopes = {
  scopes: ["group.read.all", "user.read", "directory.accessasuser.all"],
};

class AuthService {
  private static _instance: AuthService;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public scopes = {
    scopes: config.auth.scope.split(" "),
  };
  private parseJwt = (token: string) => {
    try {
      const parsedJwt = JSON.parse(atob(token.split(".")[1]));
      return parsedJwt;
    } catch (e) {
      return null;
    }
  };

  public isTokenValid = (token: string) => {
    const parsedJwt = this.parseJwt(token);
    if (!token || parsedJwt == null) {
      return false;
    }

    const tokenExpirationInMilliseconds = parsedJwt.exp * 1000;
    const isValid = tokenExpirationInMilliseconds > Date.now();

    return isValid;
  };

  public isAuthenticated(): boolean {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      return true;
    }
    return false;
  }

  public getUser(): AccountInfo | null {
    return msalInstance.getActiveAccount();
  }

  public async isAdmin(): Promise<boolean> {
    await this.getAdGroups();
    if (!_adGroups || !_adGroups.value) {
      return false;
    }
    const isAdmin = _adGroups.value.includes(
      "287e4ff2-acc7-4264-938d-b2b7ea75d9a0"
    );
    return isAdmin;
  }

  public async isUser(): Promise<boolean> {
    await this.getAdGroups();
    if (!_adGroups || !_adGroups.value) {
      return false;
    }
    const isUser = _adGroups.value.includes(
      "d6b5277b-e0a8-4d09-ac90-9b1186a064d0"
    );
    return isUser;
  }

  public async getAdGroups(): Promise<void> {
    if (!_adGroups || !_adGroups.value || _adGroups.value.length === 0) {
      const msGraphToken = (
        await msalInstance.acquireTokenSilent({
          ...msGraphScopes,
          account: msalInstance.getActiveAccount() ?? undefined,
        })
      ).accessToken;

      const url = `https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$top=200&$count=true&$filter=securityEnabled eq true`;
      const groupResponse = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "Application/json, */*",
          Authorization: `Bearer ${msGraphToken}`,
          ConsistencyLevel: "eventual",
        },
      });
      const data = await groupResponse.json();
      _adGroups.value = data.value.map((group: any) => group.id);
    }
  }

  public async getAccessToken(): Promise<string> {
    if (_token.value && this.isTokenValid(_token.value)) {
      return _token.value;
    }

    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: config.auth.scope.split(" "),
      account: msalInstance.getActiveAccount() ?? undefined,
    });
    _token.value = tokenResponse.accessToken;
    return tokenResponse.accessToken;
  }
  public setToken(token: string): void {
    _token.value = token;
  }

  public async login(): Promise<void> {
    return await msalInstance.loginRedirect(this.scopes);
  }

  public async logout(): Promise<void> {
    return msalInstance.logoutRedirect().then(() => {
      msalInstance.setActiveAccount(null);
    });
  }
}

export default AuthService.Instance;
